export const SUBMIT_IMMUNISATION_REVIEW_SUCCESS = "SUBMIT_IMMUNISATION_REVIEW_SUCCESS";

export const LOAD_IMMUNISATION_REVIEW = "LOAD_IMMUNISATION_REVIEW";

export const AUTO_SAVE_IMMUNISATION_REVIEW = "AUTO_SAVE_IMMUNISATION_REVIEW";

export const AUTO_SAVE_IMMUNISATION_REVIEW_SUCCESS = "AUTO_SAVE_IMMUNISATION_REVIEW_SUCCESS";

export const LOAD_SAVED_IMMUNISATION_REVIEW = "LOAD_SAVED_IMMUNISATION_REVIEW";
